import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { QuotaAttributes } from '@albatrosdeveloper/ave-models-package';
import { SubRouteNavigationComponent } from 'app/shared/components/sub-route-navigation/sub-route-navigation.component';

/**
 * Route Renderer
 *
 *
 * @example
 * ```typescript
 * {
 *   field: 'type',
 *   headerName: 'Cliente',
 *   cellRenderer: ,
 *   minWidth: 200
 * }
 * ```
 */
@Component({
  selector: 'app-route-cell-renderer',
  standalone: true,
  imports: [CommonModule, SubRouteNavigationComponent],
  template: `
    <div class="leading-tight"> 
      <b class="f-10" *ngIf="codeRoute">
        {{ codeRoute }} 
        <app-sub-route-navigation
          [route]="{
            routeName: nameRoute ?? '-',
            externalKeys: { 
              code: codeRoute ?? '-'
            }
          }"
          [displayMode]="'code'"
          [showIcon]="true"
          [showText]="false">
        </app-sub-route-navigation>
        <br>
      </b>
      <span *ngIf="nameRoute">
        {{ nameRoute }}
      </span>
    </div>
  `,
})
export class RouteCellRendererComponent implements CellRenderer<QuotaAttributes> {
  @Input() params!: CellRendererParams<QuotaAttributes>;

  get nameRoute(): string | null {
    return this.params.data?.subRoutesNames?.[0] || '';
  }

  get codeRoute(): string | null {
    return this.params.data?.subRoutesCodes?.[0] || '';
  }
}